package com.tovtalk.ui.screen.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.ui.platform.LocalUriHandler
import com.tovtalk.di.getKoin
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.Reply
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.Menu
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.outlined.NotificationsNone

import androidx.compose.material.icons.filled.PushPin
import androidx.compose.material.icons.filled.Share
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Tune
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.VideoLibrary
import androidx.compose.material.icons.filled.Archive
import androidx.compose.material.icons.filled.Bookmark
import androidx.compose.material.icons.filled.ArrowDownward
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.material3.pulltorefresh.rememberPullToRefreshState
import com.tovtalk.data.analytics.AnalyticsClient
import com.tovtalk.data.analytics.InteractionType
import com.tovtalk.di.koinInject
import com.tovtalk.di.disposableKoinInject
import com.tovtalk.domain.entity.Post
import com.tovtalk.domain.entity.User
import com.tovtalk.presentation.state.PagingState
import com.tovtalk.presentation.state.UiState
import com.tovtalk.presentation.viewmodel.profile.ProfileTab
import com.tovtalk.presentation.viewmodel.profile.ProfileViewModel
import com.tovtalk.presentation.viewmodel.auth.AuthSheetController
import com.tovtalk.ui.components.ReelOptionsBottomSheet
import com.tovtalk.ui.components.ReportProfileDialog
import com.tovtalk.ui.components.ShareBottomSheet
import com.tovtalk.ui.components.TovTalkAvatar
import com.tovtalk.ui.components.TovTalkButton
import com.tovtalk.ui.components.TovTalkButtonSize
import com.tovtalk.ui.components.TovTalkButtonVariant
import com.tovtalk.ui.components.TovTalkErrorState
import com.tovtalk.ui.components.TovTalkResourceNotFoundState
import com.tovtalk.utils.deeplink.DeepLinkLogger
import com.tovtalk.ui.components.TovTalkFullScreenLoading
import com.tovtalk.ui.components.TovTalkLoadingSpinner
import com.tovtalk.ui.components.TovTalkMediaFeed
import com.tovtalk.ui.components.TovTalkEmptyState
import com.tovtalk.domain.repository.AdsRepository
import com.tovtalk.ui.adaptive.LocalWindowSizeClass
import com.tovtalk.ui.adaptive.WindowSizeClass
import com.tovtalk.ui.components.BannerAdView
import com.tovtalk.ui.adaptive.responsiveGridColumns
import com.tovtalk.ui.adaptive.adaptive
import com.tovtalk.ui.adaptive.rememberScreenWidthDp
import com.tovtalk.ui.theme.TovTalkTheme
import com.tovtalk.utils.deeplink.DeepLinkBuilder
import com.tovtalk.utils.format.formatCount
import com.tovtalk.ui.navigation.Routes
import com.tovtalk.utils.config.isWeb
import com.tovtalk.utils.strings.StringProvider
import com.tovtalk.data.local.TokenManager
import androidx.compose.material3.Button
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.layout.layout
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.runtime.derivedStateOf
import com.tovtalk.ui.components.TovTalkAsyncImage
import kotlinx.coroutines.launch

private sealed class ProfileGridItem {
    data class PostItem(val post: Post) : ProfileGridItem()
    data object BannerItem : ProfileGridItem()
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ProfileScreen(
    userId: Int? = null,
    username: String? = null,
    fromPostId: Int? = null,
    onNavigateBack: (() -> Unit)? = null,
    onNavigateToPost: (profileUserId: Int, postId: Int) -> Unit,
    onNavigateToEditProfile: (() -> Unit)? = null,
    onNavigateToSettings: (() -> Unit)? = null,
    onNavigateToMessages: (() -> Unit)? = null,
    onNavigateToChat: ((Int, String) -> Unit)? = null,
    onNavigateToHome: (() -> Unit)? = null,
    onNavigateToLogin: (() -> Unit)? = null,
    onLogout: (() -> Unit)? = null,
    onBlocked: (() -> Unit)? = null,
    onNavigateToFollowers: ((Int) -> Unit)? = null,
    onNavigateToFollowing: ((Int) -> Unit)? = null,
    onNavigateToStories: ((Int) -> Unit)? = null,
    viewModel: ProfileViewModel = disposableKoinInject()
) {
    val authState by TokenManager.authStateFlow.collectAsState()
    val isGuestProfile = userId == null && username == null && authState.isGuestMode
    if (isGuestProfile) {
        GuestProfileView(
            onNavigateToSettings = onNavigateToSettings,
            onNavigateToLogin = onNavigateToLogin,
            onNavigateBack = onNavigateBack
        )
        return
    }
    val adsRepository: AdsRepository = koinInject()
    val userState by viewModel.userState.collectAsState()
    val currentUserId by viewModel.currentUserId.collectAsState()
    val showKashrutDialog by viewModel.showKashrutDialog.collectAsState()
    val kashrutDialogMessage by viewModel.kashrutDialogMessage.collectAsState()
    val currentUserIsReadOnly by viewModel.currentUserIsReadOnly.collectAsState()
    val profileReelsKashrutRestricted by viewModel.profileReelsKashrutRestricted.collectAsState()
    val reelsSortBy by viewModel.reelsSortBy.collectAsState()
    val notifyArtistContent by viewModel.notifyArtistContent.collectAsState()
    val reelsState by viewModel.reelsState.collectAsState()
    val expiredReelsState by viewModel.expiredReelsState.collectAsState()
    val savedReelsState by viewModel.savedReelsState.collectAsState()
    val selectedTab by viewModel.selectedTab.collectAsState()
    val displayedUserId = (userState as? UiState.Success)?.data?.id
    val isCurrentUser = (userId == null && username == null) || displayedUserId == currentUserId
    val isGuestMode = authState.isGuestMode
    val showAds by viewModel.showAds.collectAsState()
    val showProfileAds by viewModel.showProfileAds.collectAsState()
    val profileAdsEveryNItems by viewModel.profileAdsEveryNItems.collectAsState()
    var showLogoutDialog by remember { mutableStateOf(false) }
    var showBlockDialog by remember { mutableStateOf<User?>(null) }
    var reportProfileUserId by remember { mutableStateOf<Int?>(null) }
    val authSheetController: AuthSheetController = koinInject()
    val analyticsClient: AnalyticsClient = koinInject()
    var selectedPostForOptions by remember { mutableStateOf<Post?>(null) }
    var selectedPostForShare by remember { mutableStateOf<Post?>(null) }
    var showShareSheet by remember { mutableStateOf(false) }
    val isRefreshing by viewModel.isRefreshing.collectAsState()
    val scope = rememberCoroutineScope()
    val snackbarHostState = remember { SnackbarHostState() }

    LaunchedEffect(userId, username) {
        viewModel.loadUser(userId, username)
    }
    LaunchedEffect(userState) {
        when (val state = userState) {
            is UiState.Success -> {
                if (username != null) DeepLinkLogger.clearIfMatchesUser(username, arrived = true)
                // loadReels is already triggered inside loadUser on success — no need to call again
                // Load follow notification preferences for other users
                if (!isCurrentUser && state.data.isFollowing) {
                    viewModel.loadFollowPreferences(state.data.id)
                }
                // Expired and Saved load lazily when user switches to those tabs (viewModel.setTab)
            }
            is UiState.Error -> {
                if (username != null) DeepLinkLogger.clearIfMatchesUser(username, arrived = false)
            }
            else -> {}
        }
    }

    LogoutDialog(
        visible = showLogoutDialog,
        onDismiss = { showLogoutDialog = false },
        onConfirm = {
            showLogoutDialog = false
            viewModel.logout { onLogout?.invoke() }
        }
    )

    if (showKashrutDialog) {
        com.tovtalk.ui.components.KashrutRestrictionDialog(
            message = kashrutDialogMessage,
            onDismiss = { viewModel.dismissKashrutDialog() },
            onGoToSettings = if (currentUserIsReadOnly) {
                {
                    viewModel.dismissKashrutDialog()
                    onNavigateToSettings?.invoke()
                }
            } else null
        )
    }

    showBlockDialog?.let { user ->
        BlockUserDialog(
            user = user,
            onDismiss = { showBlockDialog = null },
            onConfirm = {
                viewModel.blockUser(user.id) {
                    showBlockDialog = null
                    onBlocked?.invoke()
                }
            }
        )
    }

    if (showShareSheet) {
        val user = (userState as? UiState.Success)?.data
        if (user != null) {
            ShareBottomSheet(
                deepLinkUrl = DeepLinkBuilder.buildProfileUrl(user.username),
                onDismiss = { showShareSheet = false }
            )
        }
    }

    reportProfileUserId?.let { uid ->
        ReportProfileDialog(
            userId = uid,
            onDismiss = { reportProfileUserId = null },
            onReported = { reportProfileUserId = null }
        )
    }

    selectedPostForOptions?.let { post ->
        ReelOptionsBottomSheet(
            post = post,
            onDismiss = { selectedPostForOptions = null },
            onMakePermanent = { viewModel.makeReelPermanent(post.id) },
            onDelete = { viewModel.deletePost(post.id) },
            onNotInterested = {
                scope.launch {
                    analyticsClient.trackInteraction(
                        postId = post.id.toLong(),
                        type = InteractionType.NOT_INTERESTED,
                        payload = mapOf("reason" to "not_interested"),
                    )
                }
            },
        )
    }


    PullToRefreshBox(
            isRefreshing = isRefreshing,
            onRefresh = {
                viewModel.loadUser(userId, username, forceRefresh = true)
            },
            modifier = Modifier
                .fillMaxSize()
                .background(TovTalkTheme.colors.backgroundPrimary)
        ) {
            when (val state = userState) {
                is UiState.Loading -> {
                    TovTalkFullScreenLoading()
                }
                is UiState.Error -> {
                    val goHome = onNavigateToHome
                    if (goHome != null) {
                        TovTalkResourceNotFoundState(
                            modifier = Modifier.align(Alignment.Center),
                            onNavigateToHome = goHome
                        )
                    } else {
                        TovTalkErrorState(
                            message = state.message,
                            onRetry = { viewModel.loadUser(userId, username) },
                            modifier = Modifier.align(Alignment.Center)
                        )
                    }
                }
                is UiState.Success -> {
                    ProfileContent(
                        user = state.data,
                        reelsState = reelsState,
                        expiredReelsState = expiredReelsState,
                        savedReelsState = savedReelsState,
                        selectedTab = selectedTab,
                        reelsSortBy = reelsSortBy,
                        highlightPostId = fromPostId,
                        onReelsSortChange = { sort ->
                            viewModel.setReelsSortBy(sort)
                        },
                        isCurrentUser = isCurrentUser,
                        profileReelsKashrutRestricted = profileReelsKashrutRestricted,
                        onNavigateToSettings = onNavigateToSettings,
                        onTabSelect = { viewModel.setTab(it) },
                        onNavigateToFollowers = { onNavigateToFollowers?.invoke(it) },
                        onNavigateToFollowing = { onNavigateToFollowing?.invoke(it) },
                        onNavigateToStories = { onNavigateToStories?.invoke(it) },
                        onShareClick = { showShareSheet = true },
                        onOpenDrawer = if (isCurrentUser) { { onNavigateToSettings?.invoke() } } else null,
                        onBlockClick = { showBlockDialog = state.data },
                        onReportProfileClick = {
                            if (isGuestMode) authSheetController.open(reason = "guest_prompt_report_title")
                            else reportProfileUserId = state.data.id
                        },
                        onBlockWhenFollowingClick = {
                            scope.launch {
                                snackbarHostState.showSnackbar(StringProvider.get(com.tovtalk.utils.strings.StringKeys.PROFILE_BLOCK_UNFOLLOW_FIRST))
                            }
                        },
                        onMessageWhenNotAllowedClick = {
                            scope.launch {
                                snackbarHostState.showSnackbar(StringProvider.get(com.tovtalk.utils.strings.StringKeys.PROFILE_USER_DOES_NOT_ACCEPT_MESSAGES))
                            }
                        },
                        onFollowClick = {
                            if (isGuestMode) authSheetController.open()
                            else if (state.data.isFollowing) viewModel.unfollowUser(state.data.id)
                            else viewModel.followUser(state.data.id)
                        },
                        onMessageClick = {
                            if (isGuestMode) authSheetController.open()
                            else onNavigateToChat?.invoke(state.data.id, state.data.fullname)
                        },
                        onEditProfileClick = { onNavigateToEditProfile?.invoke() },
                        onPostClick = { post -> onNavigateToPost(post.author.id, post.id) },
                        onPostLongPress = { post ->
                            if (isCurrentUser) selectedPostForOptions = post else selectedPostForShare = post
                        },
                        onLoadMore = { viewModel.loadReels(state.data.id) },
                        onLoadMoreExpired = { viewModel.loadExpiredReels(state.data.id) },
                        onLoadMoreSaved = { viewModel.loadSavedReels() },
                        notifyArtistContent = notifyArtistContent,
                        onNotifyToggle = { viewModel.toggleNotifyArtistContent(state.data.id) },
                        showAds = showAds,
                        showProfileAds = showProfileAds,
                        profileAdsEveryNItems = profileAdsEveryNItems,
                        adsRepository = adsRepository,
                    )
                }
                else -> {}
            }
            selectedPostForShare?.let { post ->
                ShareBottomSheet(
                    deepLinkUrl = DeepLinkBuilder.buildPostUrl(post.ref),
                    onDismiss = { selectedPostForShare = null }
                )
            }
            SnackbarHost(
                hostState = snackbarHostState,
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(TovTalkTheme.spacing.md)
            )
            ProfileTopBar(
                isCurrentUser = isCurrentUser,
                user = (userState as? UiState.Success)?.data,
                onNavigateBack = onNavigateBack,
                onOpenDrawer = if (isCurrentUser) { { onNavigateToSettings?.invoke() } } else null,
                onSettingsClick = { onNavigateToSettings?.invoke() },
                onNavigateToMessages = onNavigateToMessages,
                onLogoutClick = { showLogoutDialog = true },
                onBlockClick = { u ->
                    if (isGuestMode) authSheetController.open() else showBlockDialog = u
                },
                onShareClick = { showShareSheet = true },
                hideShareForReadOnly = (userState as? UiState.Success)?.data?.isReadOnly == true
            )
        }
    }

@Composable
private fun ProfileTabButton(
    icon: ImageVector,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val color = if (selected) TovTalkTheme.colors.textPrimary else TovTalkTheme.colors.textSecondary
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        IconButton(
            onClick = onClick,
            modifier = Modifier.size(40.dp)
        ) {
            Icon(
                imageVector = icon,
                contentDescription = null,
                tint = color,
                modifier = Modifier.size(TovTalkTheme.sizes.iconSm)
            )
        }
    }
}

@Composable
private fun ProfileReelsTabButton(
    selected: Boolean,
    currentSort: String,
    onSortChange: (String) -> Unit,
    onTabSelect: () -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    val icon = if (selected) Icons.Default.Tune else Icons.Filled.VideoLibrary
    val color = if (selected) TovTalkTheme.colors.textPrimary else TovTalkTheme.colors.textSecondary

    val sortOptions = listOf(
        "recent" to com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_RECENT,
        "views" to com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_VIEWS,
        "likes" to com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_LIKES
    )

    Box(modifier = modifier, contentAlignment = Alignment.Center) {
        IconButton(
            onClick = {
                if (selected) expanded = true else onTabSelect()
            },
            modifier = Modifier.size(40.dp)
        ) {
            Icon(
                imageVector = icon,
                contentDescription = null,
                tint = color,
                modifier = Modifier.size(TovTalkTheme.sizes.iconSm)
            )
        }
        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = Modifier.background(TovTalkTheme.colors.surfaceElevated)
        ) {
            sortOptions.forEach { (sortKey, stringKey) ->
                DropdownMenuItem(
                    text = {
                        Text(
                            text = StringProvider.get(stringKey),
                            style = TovTalkTheme.typography.labelSmall,
                            color = if (sortKey == currentSort) TovTalkTheme.colors.brand else TovTalkTheme.colors.brand.copy(alpha = TovTalkTheme.opacity.heavy)
                        )
                    },
                    onClick = {
                        if (sortKey != currentSort) onSortChange(sortKey)
                        expanded = false
                    },
                    modifier = Modifier.height(36.dp)
                )
            }
        }
    }
}

@Composable
internal fun ProfileReelsSortRow(
    currentSort: String,
    onSortChange: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    val sortOptions = listOf(
        "recent" to com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_RECENT,
        "views" to com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_VIEWS,
        "likes" to com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_LIKES
    )
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box {
            IconButton(
                onClick = { expanded = true },
                modifier = Modifier.size(28.dp)
            ) {
                Icon(
                    imageVector = Icons.Default.Tune,
                    contentDescription = StringProvider.get(com.tovtalk.utils.strings.StringKeys.PROFILE_SORT_RECENT),
                    tint = TovTalkTheme.colors.textSecondary,
                    modifier = Modifier.size(TovTalkTheme.sizes.iconXs)
                )
            }
            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.background(TovTalkTheme.colors.surfaceElevated)
            ) {
                sortOptions.forEach { (sortKey, stringKey) ->
                    DropdownMenuItem(
                        text = {
                            Text(
                                text = StringProvider.get(stringKey),
                                style = TovTalkTheme.typography.labelSmall,
                                color = if (sortKey == currentSort) TovTalkTheme.colors.brand else TovTalkTheme.colors.brand.copy(alpha = TovTalkTheme.opacity.heavy)
                            )
                        },
                        onClick = {
                            if (sortKey != currentSort) onSortChange(sortKey)
                            expanded = false
                        },
                        modifier = Modifier.height(36.dp)
                    )
                }
            }
        }
    }
}

@Composable
fun ProfileContent(
    user: User,
    reelsState: PagingState<Post>,
    expiredReelsState: PagingState<Post>,
    savedReelsState: PagingState<Post>,
    selectedTab: ProfileTab,
    reelsSortBy: String,
    highlightPostId: Int? = null,
    onReelsSortChange: (String) -> Unit,
    isCurrentUser: Boolean,
    profileReelsKashrutRestricted: Boolean = false,
    onNavigateToSettings: (() -> Unit)? = null,
    onTabSelect: (ProfileTab) -> Unit,
    onNavigateToFollowers: (Int) -> Unit = {},
    onNavigateToFollowing: (Int) -> Unit = {},
    onNavigateToStories: ((Int) -> Unit)? = null,
    onShareClick: () -> Unit = {},
    onOpenDrawer: (() -> Unit)? = null,
    onBlockClick: (User) -> Unit = {},
    onReportProfileClick: () -> Unit = {},
    onBlockWhenFollowingClick: () -> Unit = {},
    onMessageWhenNotAllowedClick: () -> Unit = {},
    onFollowClick: () -> Unit,
    onMessageClick: () -> Unit,
    onEditProfileClick: () -> Unit,
    onPostClick: (Post) -> Unit,
    onPostLongPress: (Post) -> Unit,
    onLoadMore: () -> Unit,
    onLoadMoreExpired: () -> Unit,
    onLoadMoreSaved: () -> Unit,
    notifyArtistContent: Boolean = false,
    onNotifyToggle: () -> Unit = {},
    showAds: Boolean = false,
    showProfileAds: Boolean = false,
    profileAdsEveryNItems: Int = 9,
    adsRepository: AdsRepository? = null,
) {
    val scope = rememberCoroutineScope()

    val density = LocalDensity.current
    val windowSizeClass = LocalWindowSizeClass.current
    val isCompact = windowSizeClass == WindowSizeClass.Compact
    val useCollapsingHeader = windowSizeClass == WindowSizeClass.Compact

    // Collapsing header state (Compact only)
    val collapsedHeightPx = with(density) { TovTalkTheme.spacing.topBarHeight.toPx() }
    var expandedHeightPx by remember { mutableStateOf(0f) }
    var headerOffsetPx by remember { mutableStateOf(0f) }

    val collapseProgress by remember {
        derivedStateOf {
            if (expandedHeightPx <= collapsedHeightPx) 0f
            else ((-headerOffsetPx) / (expandedHeightPx - collapsedHeightPx)).coerceIn(0f, 1f)
        }
    }

    var currentGridState by remember { mutableStateOf<androidx.compose.foundation.lazy.grid.LazyGridState?>(null) }

    val nestedScrollConnection = remember(useCollapsingHeader) {
        object : NestedScrollConnection {
            override fun onPreScroll(available: Offset, source: NestedScrollSource): Offset {
                if (!useCollapsingHeader) return Offset.Zero
                val maxOffset = -(expandedHeightPx - collapsedHeightPx)

                // Scrolling DOWN → collapse header first
                if (available.y < 0f && headerOffsetPx > maxOffset) {
                    val newOffset = (headerOffsetPx + available.y).coerceIn(maxOffset, 0f)
                    val consumed = newOffset - headerOffsetPx
                    headerOffsetPx = newOffset
                    return Offset(0f, consumed)
                }

                return Offset.Zero
            }

            override fun onPostScroll(consumed: Offset, available: Offset, source: NestedScrollSource): Offset {
                if (!useCollapsingHeader) return Offset.Zero
                val maxOffset = -(expandedHeightPx - collapsedHeightPx)

                // Scrolling UP → expand header from leftover after grid finished
                if (available.y > 0f && headerOffsetPx < 0f) {
                    val newOffset = (headerOffsetPx + available.y).coerceIn(maxOffset, 0f)
                    val used = newOffset - headerOffsetPx
                    headerOffsetPx = newOffset
                    return Offset(0f, used)
                }

                return Offset.Zero
            }
        }
    }

    val availableTabs = remember(isCurrentUser, user.isReadOnly) {
        if (isCurrentUser && !user.isReadOnly) {
            listOf(ProfileTab.REELS, ProfileTab.EXPIRED, ProfileTab.SAVED)
        } else if (isCurrentUser && user.isReadOnly) {
            listOf(ProfileTab.SAVED)
        } else {
            listOf(ProfileTab.REELS)
        }
    }

    // Extra page at the end that triggers the drawer
    val hasDrawerPage = isCurrentUser && onOpenDrawer != null
    val totalPages = availableTabs.size + if (hasDrawerPage) 1 else 0

    val pagerState = rememberPagerState(
        initialPage = availableTabs.indexOf(selectedTab).coerceAtLeast(0),
        pageCount = { totalPages }
    )

    var bioExpanded by rememberSaveable(user.id) { mutableStateOf(false) }

    // When user lands on the extra "drawer" page, open drawer and snap back
    LaunchedEffect(pagerState.currentPage) {
        if (hasDrawerPage && pagerState.currentPage == availableTabs.size) {
            onOpenDrawer?.invoke()
            // Snap back to the last real tab
            pagerState.scrollToPage(availableTabs.size - 1)
        } else {
            val tab = availableTabs.getOrNull(pagerState.currentPage) ?: return@LaunchedEffect
            if (tab != selectedTab) onTabSelect(tab)
        }
    }

    // Sync selectedTab → pager
    LaunchedEffect(selectedTab) {
        val targetPage = availableTabs.indexOf(selectedTab)
        if (targetPage >= 0 && targetPage != pagerState.currentPage) {
            pagerState.animateScrollToPage(targetPage)
        }
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .statusBarsPadding()
            .nestedScroll(nestedScrollConnection)
    ) {
        // ── Collapsing header area ──
        Box(
            modifier = Modifier
                .clipToBounds()
                .layout { measurable, constraints ->
                    val placeable = measurable.measure(constraints)
                    val reportedHeight = if (useCollapsingHeader && expandedHeightPx > 0f) {
                        (expandedHeightPx + headerOffsetPx)
                            .coerceAtLeast(collapsedHeightPx)
                            .toInt()
                    } else {
                        placeable.height
                    }
                    layout(placeable.width, reportedHeight) {
                        placeable.place(0, 0)
                    }
                }
        ) {
            // Expanded header — fades out as collapse progresses
            Box(
                modifier = Modifier
                    .onGloballyPositioned { coordinates ->
                        expandedHeightPx = coordinates.size.height.toFloat()
                    }
                    .graphicsLayer {
                        alpha = 1f - collapseProgress
                        translationY = headerOffsetPx
                    }
            ) {
                ModernProfileHeader(
                    user = user,
                    isCurrentUser = isCurrentUser,
                    onFollowClick = onFollowClick,
                    onMessageClick = onMessageClick,
                    onEditProfileClick = onEditProfileClick,
                    onShareClick = onShareClick,
                    onOpenDrawer = onOpenDrawer,
                    onBlockClick = onBlockClick,
                    onReportProfileClick = onReportProfileClick,
                    onBlockWhenFollowingClick = onBlockWhenFollowingClick,
                    onMessageWhenNotAllowedClick = onMessageWhenNotAllowedClick,
                    onNavigateToFollowers = onNavigateToFollowers,
                    onNavigateToFollowing = onNavigateToFollowing,
                    onNavigateToStories = onNavigateToStories,
                    notifyArtistContent = notifyArtistContent,
                    onNotifyToggle = onNotifyToggle,
                    bioExpanded = bioExpanded,
                    onBioExpandedChange = { bioExpanded = it },
                )
            }

            // Collapsed header — fades in (Compact only)
            if (useCollapsingHeader) {
                Box(
                    modifier = Modifier.graphicsLayer { alpha = collapseProgress }
                ) {
                    CollapsedProfileHeader(
                        user = user,
                        isCurrentUser = isCurrentUser,
                        onFollowClick = onFollowClick,
                        onEditProfileClick = onEditProfileClick,
                        onShareClick = onShareClick,
                        onOpenDrawer = onOpenDrawer,
                        onMessageWhenNotAllowedClick = onMessageWhenNotAllowedClick,
                        notifyArtistContent = notifyArtistContent,
                        onNotifyToggle = onNotifyToggle,
                    )
                }
            }
        }

        // ── Fixed tab row ──
        if (isCurrentUser && availableTabs.size > 1) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = TovTalkTheme.spacing.sm, vertical = TovTalkTheme.spacing.none),
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                if (!user.isReadOnly) {
                    ProfileReelsTabButton(
                        selected = selectedTab == ProfileTab.REELS,
                        currentSort = reelsSortBy,
                        onSortChange = onReelsSortChange,
                        onTabSelect = { onTabSelect(ProfileTab.REELS) },
                        modifier = Modifier.weight(1f)
                    )
                    ProfileTabButton(
                        icon = Icons.Filled.Archive,
                        selected = selectedTab == ProfileTab.EXPIRED,
                        onClick = { onTabSelect(ProfileTab.EXPIRED) },
                        modifier = Modifier.weight(1f)
                    )
                }
                ProfileTabButton(
                    icon = Icons.Filled.Bookmark,
                    selected = selectedTab == ProfileTab.SAVED,
                    onClick = { onTabSelect(ProfileTab.SAVED) },
                    modifier = if (user.isReadOnly) Modifier else Modifier.weight(1f)
                )
            }
        }

        // ── Separator ──
        if (isCurrentUser || !user.isReadOnly) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(2.dp)
                    .background(TovTalkTheme.colors.border.copy(alpha = TovTalkTheme.opacity.medium))
            )
        }

        // ── Grid content — swipeable between tabs ──
        if (availableTabs.size > 1 || hasDrawerPage) {
            HorizontalPager(
                state = pagerState,
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)
            ) { page ->
                if (page < availableTabs.size) {
                    val pageTab = availableTabs[page]
                    ProfileTabGrid(
                        tab = pageTab,
                        reelsState = reelsState,
                        expiredReelsState = expiredReelsState,
                        savedReelsState = savedReelsState,
                        reelsSortBy = reelsSortBy,
                        highlightPostId = highlightPostId,
                        onReelsSortChange = onReelsSortChange,
                        isCurrentUser = isCurrentUser,
                        profileReelsKashrutRestricted = profileReelsKashrutRestricted,
                        onNavigateToSettings = onNavigateToSettings,
                        onPostClick = onPostClick,
                        onPostLongPress = onPostLongPress,
                        onLoadMore = onLoadMore,
                        onLoadMoreExpired = onLoadMoreExpired,
                        onLoadMoreSaved = onLoadMoreSaved,
                        onGridStateAvailable = { currentGridState = it },
                        showAds = showAds,
                        showProfileAds = showProfileAds,
                        profileAdsEveryNItems = profileAdsEveryNItems,
                        adsRepository = adsRepository,
                    )
                } else {
                    // Placeholder page — will snap back immediately and open drawer
                    Box(Modifier.fillMaxSize())
                }
            }
        } else {
            ProfileTabGrid(
                tab = availableTabs.first(),
                reelsState = reelsState,
                expiredReelsState = expiredReelsState,
                savedReelsState = savedReelsState,
                reelsSortBy = reelsSortBy,
                highlightPostId = highlightPostId,
                onReelsSortChange = onReelsSortChange,
                isCurrentUser = isCurrentUser,
                profileReelsKashrutRestricted = profileReelsKashrutRestricted,
                onNavigateToSettings = onNavigateToSettings,
                onPostClick = onPostClick,
                onPostLongPress = onPostLongPress,
                onLoadMore = onLoadMore,
                onLoadMoreExpired = onLoadMoreExpired,
                onLoadMoreSaved = onLoadMoreSaved,
                onGridStateAvailable = { currentGridState = it },
                showAds = showAds,
                showProfileAds = showProfileAds,
                profileAdsEveryNItems = profileAdsEveryNItems,
                adsRepository = adsRepository,
                modifier = Modifier.weight(1f),
            )
        }
    }
}

/** Grid content for a single profile tab */
@Composable
private fun ProfileTabGrid(
    tab: ProfileTab,
    reelsState: PagingState<Post>,
    expiredReelsState: PagingState<Post>,
    savedReelsState: PagingState<Post>,
    reelsSortBy: String,
    highlightPostId: Int?,
    onReelsSortChange: (String) -> Unit,
    isCurrentUser: Boolean,
    profileReelsKashrutRestricted: Boolean,
    onNavigateToSettings: (() -> Unit)?,
    onPostClick: (Post) -> Unit,
    onPostLongPress: (Post) -> Unit,
    onLoadMore: () -> Unit,
    onLoadMoreExpired: () -> Unit,
    onLoadMoreSaved: () -> Unit,
    onGridStateAvailable: (androidx.compose.foundation.lazy.grid.LazyGridState) -> Unit = {},
    showAds: Boolean = false,
    showProfileAds: Boolean = false,
    profileAdsEveryNItems: Int = 9,
    adsRepository: AdsRepository? = null,
    modifier: Modifier = Modifier,
) {
    val gridState = rememberLazyGridState()
    val scope = rememberCoroutineScope()

    // Expose grid state to parent for direct reading in nested scroll
    LaunchedEffect(gridState) {
        onGridStateAvailable(gridState)
    }

    val items = when (tab) {
        ProfileTab.REELS -> reelsState.items
        ProfileTab.EXPIRED -> expiredReelsState.items
        ProfileTab.SAVED -> savedReelsState.items
    }
    val isLoading = when (tab) {
        ProfileTab.REELS -> reelsState.isLoading
        ProfileTab.EXPIRED -> expiredReelsState.isLoading
        ProfileTab.SAVED -> savedReelsState.isLoading
    }
    val loadMore: () -> Unit = when (tab) {
        ProfileTab.REELS -> onLoadMore
        ProfileTab.EXPIRED -> onLoadMoreExpired
        ProfileTab.SAVED -> onLoadMoreSaved
    }

    val highlightedIndex = remember(items, highlightPostId) {
        if (highlightPostId == null || tab != ProfileTab.REELS) -1
        else items.indexOfFirst { it.id == highlightPostId }
    }

    // Header items before grid content
    val headerCount = remember(tab, isCurrentUser, profileReelsKashrutRestricted, items.size, isLoading) {
        var count = 0
        if (tab == ProfileTab.REELS && !isCurrentUser) count += 1 // sort row
        if (tab == ProfileTab.REELS && !isCurrentUser && profileReelsKashrutRestricted) {
            count += 1
        } else if (items.isEmpty() && !isLoading) {
            count += 1
        }
        count
    }
    val highlightedGridIndex = if (highlightedIndex >= 0) headerCount + highlightedIndex else -1
    var hasSeenJustWatchedTag by remember(highlightPostId, tab) { mutableStateOf(false) }

    val shouldLoadMore by remember {
        derivedStateOf {
            val lastVisibleItemIndex = gridState.layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: -1
            lastVisibleItemIndex >= items.size - 5 && items.isNotEmpty() && !isLoading
        }
    }
    LaunchedEffect(shouldLoadMore) {
        if (shouldLoadMore) loadMore()
    }
    val highlightedTagSeen by remember {
        derivedStateOf {
            tab == ProfileTab.REELS && highlightedGridIndex >= 0 &&
                gridState.layoutInfo.visibleItemsInfo.any { it.index == highlightedGridIndex }
        }
    }
    LaunchedEffect(highlightedTagSeen) {
        if (highlightedTagSeen && !hasSeenJustWatchedTag) hasSeenJustWatchedTag = true
    }

    val columns = responsiveGridColumns(
        compact = 3,
        mediumCompact = 4,
        medium = 4,
        expanded = 5,
        large = 6,
        extraLarge = 8
    )

    val postsPerBannerBlock = columns * 3

    val gridItems = remember(items, showProfileAds, profileAdsEveryNItems, postsPerBannerBlock) {
        if (!showProfileAds || adsRepository == null || profileAdsEveryNItems <= 0) {
            items.map { ProfileGridItem.PostItem(it) }
        } else {
            val result = mutableListOf<ProfileGridItem>()
            items.forEachIndexed { index, post ->
                result.add(ProfileGridItem.PostItem(post))
                if ((index + 1) % postsPerBannerBlock == 0) result.add(ProfileGridItem.BannerItem)
            }
            result
        }
    }

    Box(modifier = modifier.fillMaxSize()) {
        LazyVerticalGrid(
            columns = GridCells.Fixed(columns),
            state = gridState,
            modifier = Modifier.fillMaxSize()
        ) {
            if (tab == ProfileTab.REELS && !isCurrentUser) {
                item(span = { GridItemSpan(maxLineSpan) }) {
                    ProfileReelsSortRow(
                        currentSort = reelsSortBy,
                        onSortChange = onReelsSortChange,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = TovTalkTheme.spacing.sm, vertical = TovTalkTheme.spacing.xs)
                    )
                }
            }
            if (tab == ProfileTab.REELS && !isCurrentUser && profileReelsKashrutRestricted) {
                item(span = { GridItemSpan(maxLineSpan) }) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(TovTalkTheme.spacing.xl)
                            .height(300.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center
                    ) {
                        Text(
                            text = StringProvider.get(com.tovtalk.utils.strings.StringKeys.KASHRUT_PROFILE_BLOCK_MESSAGE),
                            style = TovTalkTheme.typography.bodyMedium,
                            color = TovTalkTheme.colors.textSecondary,
                            textAlign = TextAlign.Center
                        )
                        onNavigateToSettings?.let { goToSettings ->
                            Button(
                                onClick = goToSettings,
                                modifier = Modifier.padding(top = TovTalkTheme.spacing.md),
                                colors = ButtonDefaults.buttonColors(
                                    containerColor = TovTalkTheme.colors.brand,
                                    contentColor = TovTalkTheme.colors.onBrand
                                )
                            ) {
                                Text(StringProvider.get(com.tovtalk.utils.strings.StringKeys.KASHRUT_UPDATE_LEVEL))
                            }
                        }
                    }
                }
            } else if (items.isEmpty() && !isLoading) {
                item(span = { GridItemSpan(maxLineSpan) }) {
                    ProfileEmptyTabState(
                        tab = tab,
                        isOwnProfile = isCurrentUser,
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(300.dp)
                    )
                }
            }
            gridItems.forEachIndexed { gridIndex, gridItem ->
                when (gridItem) {
                    is ProfileGridItem.PostItem -> item(
                        key = "post_${gridItem.post.id}",
                        contentType = "post"
                    ) {
                        ReelGridItem(
                            post = gridItem.post,
                            isJustWatched = highlightPostId != null && gridItem.post.id == highlightPostId,
                            onClick = { onPostClick(gridItem.post) },
                            onLongPress = { onPostLongPress(gridItem.post) }
                        )
                    }
                    ProfileGridItem.BannerItem -> item(
                        // PERF(7): key by the preceding post id (banners always follow a
                        // PostItem) instead of the grid index. With an index-based key, the
                        // key of every banner shifted as the list grew on append, so Compose
                        // treated them as new items and the banner ads reloaded. The preceding
                        // post id is stable across appends, so ads no longer reload.
                        key = (gridItems.getOrNull(gridIndex - 1) as? ProfileGridItem.PostItem)
                            ?.let { "banner_after_${it.post.id}" } ?: "banner_$gridIndex",
                        span = { GridItemSpan(maxLineSpan) },
                        contentType = "banner"
                    ) {
                        BannerAdRow(adsRepository = adsRepository)
                    }
                }
            }
            if (isLoading) {
                item(span = { GridItemSpan(maxLineSpan) }) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(TovTalkTheme.spacing.lg),
                        contentAlignment = Alignment.Center
                    ) {
                        TovTalkLoadingSpinner(size = TovTalkTheme.sizes.iconLg)
                    }
                }
            }
        }

        if (tab == ProfileTab.REELS) {
            val watchedNotVisible =
                highlightedGridIndex >= 0 &&
                    !hasSeenJustWatchedTag &&
                    gridState.layoutInfo.visibleItemsInfo.none { it.index == highlightedGridIndex }
            if (watchedNotVisible) {
                Surface(
                    onClick = {
                        scope.launch {
                            gridState.animateScrollToItem(highlightedGridIndex)
                        }
                    },
                    shape = RectangleShape,
                    color = TovTalkTheme.colors.surfaceOverlay.copy(alpha = 0.92f),
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .padding(bottom = TovTalkTheme.spacing.xl)
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = TovTalkTheme.spacing.sm, vertical = TovTalkTheme.spacing.xs),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxs)
                    ) {
                        Icon(
                            imageVector = Icons.Default.ArrowDownward,
                            contentDescription = null,
                            tint = TovTalkTheme.colors.textPrimary,
                            modifier = Modifier.size(TovTalkTheme.sizes.iconXs)
                        )
                        Text(
                            text = "לסרטון שנצפה",
                            style = TovTalkTheme.typography.labelSmall,
                            color = TovTalkTheme.colors.textPrimary
                        )
                    }
                }
            }
        }
    }
}

/** Empty state with tab-specific messaging */
@Composable
private fun ProfileEmptyTabState(
    tab: ProfileTab,
    isOwnProfile: Boolean,
    modifier: Modifier = Modifier
) {
    val (icon, title, description) = when {
        tab == ProfileTab.REELS && isOwnProfile -> Triple(
            Icons.Default.VideoLibrary,
            StringProvider.get("empty_share_first_video"),
            StringProvider.get("empty_tap_to_create")
        )
        tab == ProfileTab.REELS -> Triple(
            Icons.Default.VideoLibrary,
            StringProvider.get("empty_no_videos_title"),
            null
        )
        tab == ProfileTab.EXPIRED -> Triple(
            Icons.Default.Archive,
            "אין סרטונים בארכיון",
            "סרטונים שתקופת ההצגה שלהם הסתיימה יופיעו כאן"
        )
        else -> Triple(
            Icons.Default.Bookmark,
            "אין סרטונים שמורים",
            "סרטונים ששמרת יופיעו כאן"
        )
    }
    TovTalkEmptyState(
        icon = icon,
        title = title,
        description = description,
        modifier = modifier
    )
}

@Composable
fun ModernProfileHeader(
    user: User,
    isCurrentUser: Boolean,
    onFollowClick: () -> Unit,
    onMessageClick: () -> Unit,
    onEditProfileClick: () -> Unit,
    onShareClick: () -> Unit = {},
    onOpenDrawer: (() -> Unit)? = null,
    onBlockClick: (User) -> Unit = {},
    onReportProfileClick: () -> Unit = {},
    onBlockWhenFollowingClick: () -> Unit = {},
    onMessageWhenNotAllowedClick: () -> Unit = {},
    onNavigateToFollowers: (Int) -> Unit = {},
    onNavigateToFollowing: (Int) -> Unit = {},
    onNavigateToStories: ((Int) -> Unit)? = null,
    notifyArtistContent: Boolean = false,
    onNotifyToggle: () -> Unit = {},
    bioExpanded: Boolean = false,
    onBioExpandedChange: (Boolean) -> Unit = {},
) {
    val windowSizeClass = LocalWindowSizeClass.current
    if (windowSizeClass == WindowSizeClass.Compact) {
        VerticalProfileHeader(
            user = user,
            isCurrentUser = isCurrentUser,
            onFollowClick = onFollowClick,
            onMessageClick = onMessageClick,
            onEditProfileClick = onEditProfileClick,
            onShareClick = onShareClick,
            onOpenDrawer = onOpenDrawer,
            onMessageWhenNotAllowedClick = onMessageWhenNotAllowedClick,
            onNavigateToFollowers = onNavigateToFollowers,
            onNavigateToFollowing = onNavigateToFollowing,
            onNavigateToStories = onNavigateToStories,
            notifyArtistContent = notifyArtistContent,
            onNotifyToggle = onNotifyToggle,
            bioExpanded = bioExpanded,
            onBioExpandedChange = onBioExpandedChange,
        )
    } else {
        val maxHeaderWidth = when (windowSizeClass) {
            WindowSizeClass.MediumCompact -> 540.dp
            WindowSizeClass.Medium -> 680.dp
            WindowSizeClass.Expanded -> 800.dp
            WindowSizeClass.Large -> 900.dp
            WindowSizeClass.ExtraLarge -> 1000.dp
            else -> 420.dp
        }
        Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.TopCenter) {
            Box(modifier = Modifier.widthIn(max = maxHeaderWidth)) {
                HorizontalProfileHeader(
                    user = user,
                    isCurrentUser = isCurrentUser,
                    onFollowClick = onFollowClick,
                    onMessageClick = onMessageClick,
                    onEditProfileClick = onEditProfileClick,
                    onShareClick = onShareClick,
                    onOpenDrawer = onOpenDrawer,
                    onMessageWhenNotAllowedClick = onMessageWhenNotAllowedClick,
                    onNavigateToFollowers = onNavigateToFollowers,
                    onNavigateToFollowing = onNavigateToFollowing,
                    onNavigateToStories = onNavigateToStories,
                    notifyArtistContent = notifyArtistContent,
                    onNotifyToggle = onNotifyToggle,
                    bioExpanded = bioExpanded,
                    onBioExpandedChange = onBioExpandedChange,
                )
            }
        }
    }
}

/** Horizontal profile header for Medium/Expanded window sizes */
@Composable
private fun HorizontalProfileHeader(
    user: User,
    isCurrentUser: Boolean,
    onFollowClick: () -> Unit,
    onMessageClick: () -> Unit,
    onEditProfileClick: () -> Unit,
    onShareClick: () -> Unit,
    onOpenDrawer: (() -> Unit)?,
    onMessageWhenNotAllowedClick: () -> Unit,
    onNavigateToFollowers: (Int) -> Unit,
    onNavigateToFollowing: (Int) -> Unit,
    onNavigateToStories: ((Int) -> Unit)? = null,
    notifyArtistContent: Boolean,
    onNotifyToggle: () -> Unit,
    bioExpanded: Boolean = false,
    onBioExpandedChange: (Boolean) -> Unit = {},
) {
    val kashrutText = user.artistType?.let { StringProvider.get("kashrut_level_$it") }
    val headerHorizontalPadding = TovTalkTheme.spacing.sm + TovTalkTheme.spacing.md

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = headerHorizontalPadding)
            .padding(top = TovTalkTheme.spacing.md, bottom = TovTalkTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.md)
    ) {
        // Avatar on start side
        TovTalkAvatar(
            imageUrl = user.profilePhoto,
            size = TovTalkTheme.sizes.avatarXl + 8.dp,
            name = user.fullname,
            hasStory = user.hasActiveStory && onNavigateToStories != null,
            onStoryClick = onNavigateToStories?.let { nav -> { nav(user.id) } }
        )

        // Name + username + bio in the middle
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxs)
        ) {
            Text(
                text = user.fullname.ifBlank { user.username },
                style = TovTalkTheme.typography.titleMedium,
                color = TovTalkTheme.colors.textPrimary
            )
            Text(
                text = "@${user.username}",
                style = TovTalkTheme.typography.bodySmall,
                color = TovTalkTheme.colors.textSecondary
            )
            if (!kashrutText.isNullOrBlank()) {
                Text(
                    text = "רמת כשרות: $kashrutText",
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.textSecondary
                )
            }
            val hasBio = !user.bio.isNullOrBlank()
            if (hasBio) {
                Text(
                    text = user.bio!!,
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.textPrimary,
                    maxLines = if (bioExpanded) Int.MAX_VALUE else 2,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.clickable { onBioExpandedChange(!bioExpanded) }
                )
                Text(
                    text = if (bioExpanded) StringProvider.get("profile_bio_show_less") else StringProvider.get("profile_bio_show_more"),
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.brand,
                    modifier = Modifier.clickable { onBioExpandedChange(!bioExpanded) }
                )
            }
        }

        // Stats (posts, followers, following)
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxs)
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.sm),
                verticalAlignment = Alignment.CenterVertically
            ) {
                ProfileMetricColumn(
                    count = user.followingCount.toLong(),
                    label = StringProvider.get("profile_following"),
                    isClickable = isCurrentUser,
                    onClick = { onNavigateToFollowing(user.id) }
                )
                ProfileMetricColumn(
                    count = user.followerCount.toLong(),
                    label = StringProvider.get("profile_followers"),
                    isClickable = isCurrentUser,
                    onClick = { onNavigateToFollowers(user.id) }
                )
                ProfileMetricColumn(
                    count = user.totalPostLikesCount.toLong(),
                    label = StringProvider.get("profile_likes"),
                    isClickable = false
                )
            }
        }

        // Follow/Edit button + action icons
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxs)
        ) {
            if (isCurrentUser) {
                TovTalkButton(
                    text = StringProvider.get("profile_edit"),
                    onClick = onEditProfileClick,
                    variant = TovTalkButtonVariant.Secondary,
                    size = TovTalkButtonSize.Medium,
                )
            } else {
                ProfileFollowPillButton(
                    text = if (user.isFollowing) StringProvider.get("profile_unfollow") else StringProvider.get("profile_follow"),
                    onClick = onFollowClick,
                    backgroundColor = TovTalkTheme.colors.brandLight.copy(alpha = TovTalkTheme.opacity.moderate),
                    contentColor = TovTalkTheme.colors.brand,
                )
            }
            Row(
                horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxxs),
                verticalAlignment = Alignment.CenterVertically
            ) {
                IconButton(
                    onClick = onShareClick,
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = Icons.AutoMirrored.Filled.Reply,
                        contentDescription = StringProvider.get("accessibility_share"),
                        tint = TovTalkTheme.colors.textSecondary
                    )
                }
                if (!isCurrentUser && user.isFollowing) {
                    IconButton(
                        onClick = onNotifyToggle,
                        modifier = Modifier.size(36.dp)
                    ) {
                        Icon(
                            imageVector = if (notifyArtistContent) Icons.Default.Notifications else Icons.Outlined.NotificationsNone,
                            contentDescription = "artist notifications",
                            tint = if (notifyArtistContent) TovTalkTheme.colors.brand else TovTalkTheme.colors.textSecondary
                        )
                    }
                } else if (onOpenDrawer != null) {
                    IconButton(
                        onClick = onOpenDrawer,
                        modifier = Modifier.size(36.dp)
                    ) {
                        Icon(
                            imageVector = Icons.Default.Menu,
                            contentDescription = StringProvider.get("settings_title"),
                            tint = TovTalkTheme.colors.textSecondary
                        )
                    }
                }
            }
        }
    }
}

/** Original vertical profile header for Compact window size */
@Composable
private fun VerticalProfileHeader(
    user: User,
    isCurrentUser: Boolean,
    onFollowClick: () -> Unit,
    onMessageClick: () -> Unit,
    onEditProfileClick: () -> Unit,
    onShareClick: () -> Unit,
    onOpenDrawer: (() -> Unit)?,
    onMessageWhenNotAllowedClick: () -> Unit,
    onNavigateToFollowers: (Int) -> Unit,
    onNavigateToFollowing: (Int) -> Unit,
    onNavigateToStories: ((Int) -> Unit)? = null,
    notifyArtistContent: Boolean,
    onNotifyToggle: () -> Unit,
    bioExpanded: Boolean = false,
    onBioExpandedChange: (Boolean) -> Unit = {},
) {
    val kashrutText = user.artistType?.let { StringProvider.get("kashrut_level_$it") }
    val headerHorizontalPadding = TovTalkTheme.spacing.sm + TovTalkTheme.spacing.md
    Box(modifier = Modifier.fillMaxWidth()) {
        // Top-right action icons — same position and style for both own and other profiles.
        Row(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .padding(end = headerHorizontalPadding),
            horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxs),
            verticalAlignment = Alignment.CenterVertically
        ) {
            // Share icon — always leftmost (fixed position)
            IconButton(
                onClick = onShareClick,
                modifier = Modifier.size(36.dp)
            ) {
                Icon(
                    imageVector = Icons.AutoMirrored.Filled.Reply,
                    contentDescription = StringProvider.get("accessibility_share"),
                    tint = TovTalkTheme.colors.textSecondary
                )
            }
            // Second icon: notifications (only if following) or menu (own) — changes per profile
            if (!isCurrentUser && user.isFollowing) {
                IconButton(
                    onClick = onNotifyToggle,
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = if (notifyArtistContent) Icons.Default.Notifications else Icons.Outlined.NotificationsNone,
                        contentDescription = "artist notifications",
                        tint = if (notifyArtistContent) TovTalkTheme.colors.brand else TovTalkTheme.colors.textSecondary
                    )
                }
            } else if (onOpenDrawer != null) {
                IconButton(
                    onClick = onOpenDrawer,
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.Menu,
                        contentDescription = StringProvider.get("settings_title"),
                        tint = TovTalkTheme.colors.textSecondary
                    )
                }
            }
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = headerHorizontalPadding)
                .padding(top = TovTalkTheme.spacing.md, bottom = TovTalkTheme.spacing.xxs),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            TovTalkAvatar(
                imageUrl = user.profilePhoto,
                // Slightly larger profile image per design request.
                size = TovTalkTheme.sizes.avatarXl + 8.dp,
                name = user.fullname,
                hasStory = user.hasActiveStory && onNavigateToStories != null,
                onStoryClick = onNavigateToStories?.let { nav -> { nav(user.id) } }
            )
            Spacer(modifier = Modifier.height(TovTalkTheme.spacing.xs))
            Text(
                text = user.fullname.ifBlank { user.username },
                style = TovTalkTheme.typography.titleMedium,
                color = TovTalkTheme.colors.textPrimary,
                textAlign = TextAlign.Center
            )
            Text(
                text = "@${user.username}",
                style = TovTalkTheme.typography.bodySmall,
                color = TovTalkTheme.colors.textSecondary
            )
            if (!kashrutText.isNullOrBlank()) {
                Spacer(modifier = Modifier.height(TovTalkTheme.spacing.xs))
                Text(
                    text = "רמת כשרות: $kashrutText",
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.textSecondary
                )
            }

            // More vertical separation between avatar/name and the follow/follower/likes row.
            Spacer(modifier = Modifier.height(TovTalkTheme.spacing.md))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xs, Alignment.CenterHorizontally),
                verticalAlignment = Alignment.CenterVertically
            ) {
                ProfileMetricColumn(
                    count = user.followingCount.toLong(),
                    label = StringProvider.get("profile_following"),
                    modifier = Modifier.weight(1f),
                    isClickable = isCurrentUser,
                    onClick = { onNavigateToFollowing(user.id) }
                )
                Text(
                    text = "|",
                    style = TovTalkTheme.typography.labelSmall,
                    color = TovTalkTheme.colors.textSecondary.copy(alpha = TovTalkTheme.opacity.dominant)
                )
                ProfileMetricColumn(
                    count = user.followerCount.toLong(),
                    label = StringProvider.get("profile_followers"),
                    modifier = Modifier.weight(1f),
                    isClickable = isCurrentUser,
                    onClick = { onNavigateToFollowers(user.id) }
                )
                Text(
                    text = "|",
                    style = TovTalkTheme.typography.labelSmall,
                    color = TovTalkTheme.colors.textSecondary.copy(alpha = TovTalkTheme.opacity.dominant)
                )
                ProfileMetricColumn(
                    count = user.totalPostLikesCount.toLong(),
                    label = StringProvider.get("profile_likes"),
                    modifier = Modifier.weight(1f),
                    isClickable = false
                )
            }

            Spacer(modifier = Modifier.height(TovTalkTheme.spacing.xs))
            if (isCurrentUser) {
                TovTalkButton(
                    text = StringProvider.get("profile_edit"),
                    onClick = onEditProfileClick,
                    variant = TovTalkButtonVariant.Secondary,
                    size = TovTalkButtonSize.Medium,
                    modifier = Modifier.fillMaxWidth(),
                    fullWidth = true
                )
            } else {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    // Follow + message pills (rounded, no strong blue frame).
                    Row(
                        modifier = Modifier.fillMaxWidth(0.7f),
                        horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xs),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        ProfileFollowPillButton(
                            text = if (user.isFollowing) StringProvider.get("profile_unfollow") else StringProvider.get("profile_follow"),
                            onClick = onFollowClick,
                            backgroundColor = TovTalkTheme.colors.brandLight.copy(alpha = TovTalkTheme.opacity.moderate),
                            contentColor = TovTalkTheme.colors.brand,
                            modifier = Modifier.weight(1f)
                        )
                        ProfileMessagePillButton(
                            text = StringProvider.get("profile_message"),
                            onClick = if (user.receiveMessage) onMessageClick else onMessageWhenNotAllowedClick,
                            backgroundColor = TovTalkTheme.colors.surfaceOverlay.copy(alpha = TovTalkTheme.opacity.subtle),
                            borderColor = TovTalkTheme.colors.brand.copy(alpha = TovTalkTheme.opacity.moderate),
                            contentColor = TovTalkTheme.colors.brand,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }

            val hasBio = !user.bio.isNullOrBlank()
            if (hasBio) {
                Spacer(modifier = Modifier.height(TovTalkTheme.spacing.sm))
                Text(
                    text = user.bio!!,
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.textPrimary,
                    textAlign = TextAlign.Center,
                    maxLines = if (bioExpanded) Int.MAX_VALUE else 4,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { onBioExpandedChange(!bioExpanded) }
                )
                Text(
                    text = if (bioExpanded) StringProvider.get("profile_bio_show_less") else StringProvider.get("profile_bio_show_more"),
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.brand,
                    textAlign = TextAlign.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { onBioExpandedChange(!bioExpanded) }
                )
            } else if (isCurrentUser) {
                Spacer(modifier = Modifier.height(TovTalkTheme.spacing.sm))
                Text(
                    text = StringProvider.get("profile_add_bio"),
                    style = TovTalkTheme.typography.bodySmall,
                    color = TovTalkTheme.colors.textSecondary,
                    textAlign = TextAlign.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable(onClick = onEditProfileClick)
                )
            }
        }
    }
}

/** Compact collapsed header — single row shown when collapseProgress = 1.0 */
@Composable
private fun CollapsedProfileHeader(
    user: User,
    isCurrentUser: Boolean,
    onFollowClick: () -> Unit,
    onEditProfileClick: () -> Unit,
    onShareClick: () -> Unit,
    onOpenDrawer: (() -> Unit)?,
    onMessageWhenNotAllowedClick: () -> Unit,
    notifyArtistContent: Boolean,
    onNotifyToggle: () -> Unit,
) {
    val headerHorizontalPadding = TovTalkTheme.spacing.sm + TovTalkTheme.spacing.md

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(TovTalkTheme.spacing.topBarHeight)
            .padding(horizontal = headerHorizontalPadding),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xs)
    ) {
        TovTalkAvatar(
            imageUrl = user.profilePhoto,
            size = TovTalkTheme.sizes.avatarSm,
            name = user.fullname
        )

        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = user.fullname.ifBlank { user.username },
                style = TovTalkTheme.typography.titleSmall,
                color = TovTalkTheme.colors.textPrimary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = "@${user.username}",
                style = TovTalkTheme.typography.bodySmall,
                color = TovTalkTheme.colors.textSecondary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }

        if (isCurrentUser) {
            TovTalkButton(
                text = StringProvider.get("profile_edit"),
                onClick = onEditProfileClick,
                variant = TovTalkButtonVariant.Secondary,
                size = TovTalkButtonSize.Medium,
            )
        } else {
            ProfileFollowPillButton(
                text = if (user.isFollowing) StringProvider.get("profile_unfollow") else StringProvider.get("profile_follow"),
                onClick = onFollowClick,
                backgroundColor = TovTalkTheme.colors.brandLight.copy(alpha = TovTalkTheme.opacity.moderate),
                contentColor = TovTalkTheme.colors.brand,
            )
        }

        IconButton(onClick = onShareClick, modifier = Modifier.size(36.dp)) {
            Icon(
                imageVector = Icons.AutoMirrored.Filled.Reply,
                contentDescription = StringProvider.get("accessibility_share"),
                tint = TovTalkTheme.colors.textSecondary
            )
        }
        if (!isCurrentUser && user.isFollowing) {
            IconButton(onClick = onNotifyToggle, modifier = Modifier.size(36.dp)) {
                Icon(
                    imageVector = if (notifyArtistContent) Icons.Default.Notifications else Icons.Outlined.NotificationsNone,
                    contentDescription = "artist notifications",
                    tint = if (notifyArtistContent) TovTalkTheme.colors.brand else TovTalkTheme.colors.textSecondary
                )
            }
        } else if (onOpenDrawer != null) {
            IconButton(onClick = onOpenDrawer, modifier = Modifier.size(36.dp)) {
                Icon(
                    imageVector = Icons.Default.Menu,
                    contentDescription = StringProvider.get("settings_title"),
                    tint = TovTalkTheme.colors.textSecondary
                )
            }
        }
    }
}

@Composable
private fun ProfileFollowPillButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: Color,
    contentColor: Color,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .height(TovTalkTheme.sizes.buttonHeightSm)
            .clip(TovTalkTheme.shapes.full)
            .background(backgroundColor)
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = text,
            style = TovTalkTheme.typography.labelMedium,
            color = contentColor,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(horizontal = TovTalkTheme.spacing.sm)
        )
    }
}

@Composable
private fun ProfileMessagePillButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: Color,
    borderColor: Color,
    contentColor: Color,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .height(TovTalkTheme.sizes.buttonHeightSm)
            .clip(TovTalkTheme.shapes.full)
            .background(backgroundColor)
            .border(width = 1.dp, color = borderColor, shape = TovTalkTheme.shapes.full)
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = text,
            style = TovTalkTheme.typography.labelMedium,
            color = contentColor,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(horizontal = TovTalkTheme.spacing.sm)
        )
    }
}

@Composable
private fun ProfileKashrutChip(
    contentLevel: Int,
    modifier: Modifier = Modifier
) {
    val label = StringProvider.get("kashrut_level_$contentLevel")
    Column(
        modifier = modifier
            .clip(TovTalkTheme.shapes.small)
            .background(TovTalkTheme.colors.surfaceOverlay)
            .padding(horizontal = TovTalkTheme.spacing.xs, vertical = TovTalkTheme.spacing.xxs),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = label,
            style = TovTalkTheme.typography.titleMedium,
            color = TovTalkTheme.colors.textPrimary
        )
        Text(
            text = " ",
            style = TovTalkTheme.typography.labelSmall,
            color = TovTalkTheme.colors.textSecondary
        )
    }
}

@Composable
private fun ProfileStatChip(
    count: Int,
    label: String,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .clip(TovTalkTheme.shapes.small)
            .background(TovTalkTheme.colors.surfaceOverlay)
            .padding(horizontal = TovTalkTheme.spacing.xs, vertical = TovTalkTheme.spacing.xxs),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = formatCount(count.toLong()),
            style = TovTalkTheme.typography.titleMedium,
            color = TovTalkTheme.colors.textPrimary
        )
        Text(
            text = label,
            style = TovTalkTheme.typography.labelSmall,
            color = TovTalkTheme.colors.textSecondary
        )
    }
}

@Composable
private fun ProfileMetricColumn(
    count: Long,
    label: String,
    modifier: Modifier = Modifier,
    isClickable: Boolean = false,
    onClick: (() -> Unit)? = null
) {
    Column(
        modifier = modifier.then(
            if (isClickable && onClick != null) Modifier.clickable { onClick() } else Modifier
        ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = formatCount(count),
            style = TovTalkTheme.typography.titleSmall,
            color = TovTalkTheme.colors.textPrimary,
            textAlign = TextAlign.Center
        )
        Text(
            text = label,
            style = TovTalkTheme.typography.labelSmall,
            color = TovTalkTheme.colors.textSecondary,
            textAlign = TextAlign.Center
        )
    }
}

@Composable
private fun ReelGridItem(
    post: Post,
    isJustWatched: Boolean = false,
    onClick: () -> Unit,
    onLongPress: () -> Unit
) {
    Box(
        modifier = Modifier
            .aspectRatio(15f / 20f)
            .padding(1.dp)
            .clip(TovTalkTheme.shapes.small)
            .background(TovTalkTheme.colors.surfaceOverlay)
            .pointerInput(Unit) {
                detectTapGestures(
                    onTap = { onClick() },
                    onLongPress = { onLongPress() }
                )
            }
    ) {
        // Container is shorter than 9:16 video — ContentScale.Crop fills width
        // and clips ~0.5cm from top and bottom naturally.
        TovTalkMediaFeed(
            imageUrl = post.thumbnail,
            modifier = Modifier.fillMaxSize(),
            fillCell = true
        )
        if (isJustWatched) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(TovTalkTheme.colors.surfaceOverlay.copy(alpha = TovTalkTheme.opacity.semiStrong))
            )
            Text(
                text = "זה עתה נצפה",
                style = TovTalkTheme.typography.labelSmall,
                color = TovTalkTheme.colors.textPrimary,
                modifier = Modifier
                    .align(Alignment.Center)
                    .background(TovTalkTheme.colors.surfaceOverlay.copy(alpha = TovTalkTheme.opacity.opaque), RectangleShape)
                    .padding(horizontal = TovTalkTheme.spacing.sm, vertical = TovTalkTheme.spacing.xxs)
            )
        }
        Row(
            modifier = Modifier
                .align(Alignment.BottomStart)
                .padding(TovTalkTheme.spacing.xxs),
            horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxs),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Row(
                modifier = Modifier
                    .clip(TovTalkTheme.shapes.small)
                    .background(TovTalkTheme.colors.overlayDark)
                    .padding(horizontal = TovTalkTheme.spacing.xxs, vertical = TovTalkTheme.spacing.xxxs),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxxs)
            ) {
                Icon(
                    imageVector = Icons.Default.Visibility,
                    contentDescription = null,
                    modifier = Modifier.size(TovTalkTheme.sizes.iconXs),
                    tint = TovTalkTheme.colors.onBrand
                )
                Text(
                    text = formatCount(post.stats.views),
                    style = TovTalkTheme.typography.labelSmall,
                    color = TovTalkTheme.colors.onBrand
                )
            }
            Row(
                modifier = Modifier
                    .clip(TovTalkTheme.shapes.small)
                    .background(TovTalkTheme.colors.overlayDark)
                    .padding(horizontal = TovTalkTheme.spacing.xxs, vertical = TovTalkTheme.spacing.xxxs),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.xxxs)
            ) {
                Icon(
                    imageVector = Icons.Default.Favorite,
                    contentDescription = null,
                    modifier = Modifier.size(TovTalkTheme.sizes.iconXs),
                    tint = TovTalkTheme.colors.onBrand
                )
                Text(
                    text = formatCount(post.stats.likes),
                    style = TovTalkTheme.typography.labelSmall,
                    color = TovTalkTheme.colors.onBrand
                )
            }
        }
        if (post.isPinned == true) {
            Icon(
                Icons.Default.PushPin,
                contentDescription = StringProvider.get("video_pinned"),
                modifier = Modifier
                    .size(TovTalkTheme.sizes.iconXs)
                    .align(Alignment.TopEnd)
                    .padding(TovTalkTheme.spacing.xxs),
                tint = TovTalkTheme.colors.onBrand
            )
        }
        if (post.isPermanent == false) {
            Box(
                modifier = Modifier
                    .align(Alignment.TopStart)
                    .padding(TovTalkTheme.spacing.xxs)
                    .clip(TovTalkTheme.shapes.small)
                    .background(TovTalkTheme.colors.warning.copy(alpha = TovTalkTheme.opacity.opaque))
                    .padding(horizontal = TovTalkTheme.spacing.xxs, vertical = TovTalkTheme.spacing.xxxs)
            ) {
                Text(
                    text = StringProvider.get("profile_24h"),
                    style = TovTalkTheme.typography.labelSmall,
                    color = TovTalkTheme.colors.onBrand
                )
            }
        }
    }
}

@Composable
private fun GuestProfileView(
    onNavigateToSettings: (() -> Unit)?,
    onNavigateToLogin: (() -> Unit)?,
    onNavigateBack: (() -> Unit)?
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(TovTalkTheme.colors.backgroundPrimary)
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .statusBarsPadding()
                .padding(TovTalkTheme.spacing.lg),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            TovTalkAvatar(
                imageUrl = null,
                size = TovTalkTheme.sizes.avatarXl,
                name = StringProvider.get("profile_guest")
            )
            Spacer(modifier = Modifier.height(TovTalkTheme.spacing.md))
            Text(
                text = StringProvider.get("profile_guest"),
                style = TovTalkTheme.typography.titleMedium,
                color = TovTalkTheme.colors.textPrimary
            )
            Spacer(modifier = Modifier.height(TovTalkTheme.spacing.xs))
            Text(
                text = StringProvider.get("profile_guest_subtitle"),
                style = TovTalkTheme.typography.bodyMedium,
                color = TovTalkTheme.colors.textSecondary
            )
            Spacer(modifier = Modifier.height(TovTalkTheme.spacing.xl))
            onNavigateToLogin?.let { onLogin ->
                TovTalkButton(
                    text = StringProvider.get("nav_login"),
                    onClick = onLogin,
                    modifier = Modifier.fillMaxWidth(),
                    variant = TovTalkButtonVariant.Primary,
                    size = TovTalkButtonSize.Large
                )
            }
        }
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = TovTalkTheme.spacing.xs, vertical = TovTalkTheme.spacing.xs),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (onNavigateBack != null) {
                IconButton(
                    onClick = onNavigateBack,
                    modifier = Modifier
                        .size(TovTalkTheme.sizes.minTouchTarget)
                        .clip(CircleShape)
                        .background(TovTalkTheme.colors.surfaceOverlay)
                ) {
                    Icon(
                        Icons.AutoMirrored.Filled.ArrowBack,
                        contentDescription = null,
                        tint = TovTalkTheme.colors.textPrimary
                    )
                }
            } else {
                Spacer(modifier = Modifier.size(TovTalkTheme.sizes.minTouchTarget))
            }
            onNavigateToSettings?.let { onSettings ->
                IconButton(
                    onClick = onSettings,
                    modifier = Modifier
                        .size(TovTalkTheme.sizes.minTouchTarget)
                        .clip(CircleShape)
                        .background(TovTalkTheme.colors.surfaceOverlay)
                ) {
                    Icon(
                        Icons.Default.Settings,
                        contentDescription = null,
                        tint = TovTalkTheme.colors.textPrimary
                    )
                }
            } ?: Spacer(modifier = Modifier.size(TovTalkTheme.sizes.minTouchTarget))
        }
    }
}

@Composable
private fun ProfileTopBar(
    isCurrentUser: Boolean,
    user: User? = null,
    onNavigateBack: (() -> Unit)?,
    onOpenDrawer: (() -> Unit)? = null,
    onSettingsClick: () -> Unit,
    onNavigateToMessages: (() -> Unit)? = null,
    onLogoutClick: () -> Unit,
    onBlockClick: (User) -> Unit = {},
    onShareClick: () -> Unit = {},
    hideShareForReadOnly: Boolean = false
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .statusBarsPadding()
            .padding(horizontal = TovTalkTheme.spacing.xs, vertical = TovTalkTheme.spacing.xs)
    ) {
        // Share + menu icons moved to ModernProfileHeader for consistent positioning.
        // ProfileTopBar is now empty for current user (icons are in the header).
    }
}

@Composable
private fun BlockUserDialog(
    user: User,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(StringProvider.get("profile_block_user"), style = TovTalkTheme.typography.titleMedium) },
        text = {
            Text(
                StringProvider.get("profile_block_confirm", user.fullname.ifBlank { user.username }),
                style = TovTalkTheme.typography.bodyMedium
            )
        },
        confirmButton = {
            TextButton(
                onClick = onConfirm,
                colors = ButtonDefaults.textButtonColors(contentColor = TovTalkTheme.colors.error)
            ) {
                Text(StringProvider.get("profile_block_user"))
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(StringProvider.get("common_cancel"))
            }
        },
        containerColor = TovTalkTheme.colors.surfaceElevated
    )
}

@Composable
private fun BannerAdRow(
    adsRepository: AdsRepository? = null,
    modifier: Modifier = Modifier
) {
    val screenWidthDp by rememberScreenWidthDp()
    val navWidth = adaptive(
        compact = 0f,
        mediumCompact = 0f,
        medium = 56f,
        expanded = 56f,
        large = 220f,
        extraLarge = 220f
    )
    val gridWidth = screenWidthDp - navWidth
    val bannerCount = maxOf(1, (gridWidth / (320f + 12f)).toInt())

    var bannerUrl by remember { mutableStateOf<String?>(null) }
    LaunchedEffect(Unit) {
        bannerUrl = runCatching { adsRepository?.buildBannerUrl() }.getOrNull()
    }

    val url = bannerUrl ?: return

    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(vertical = 8.dp),
        horizontalArrangement = Arrangement.Center
    ) {
        repeat(bannerCount) { index ->
            if (index > 0) Spacer(modifier = Modifier.width(12.dp))
            BannerAdView(url = url, modifier = Modifier.width(320.dp).height(50.dp))
        }
    }
}

@Composable
private fun LogoutDialog(
    visible: Boolean,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    if (visible) {
        AlertDialog(
            onDismissRequest = onDismiss,
            title = { Text(StringProvider.get("profile_logout"), style = TovTalkTheme.typography.titleMedium) },
            text = { Text(StringProvider.get("profile_logout_confirm"), style = TovTalkTheme.typography.bodyMedium) },
            confirmButton = {
                TextButton(
                    onClick = onConfirm,
                    colors = ButtonDefaults.textButtonColors(contentColor = TovTalkTheme.colors.error)
                ) {
                    Text(StringProvider.get("profile_logout"))
                }
            },
            dismissButton = {
                TextButton(onClick = onDismiss) {
                    Text(StringProvider.get("common_cancel"))
                }
            },
            containerColor = TovTalkTheme.colors.surfaceElevated
        )
    }
}
